export default __webpack_public_path__ + "static/media/checked_box.9603e5e5.svg";